"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TokenValueChips = TokenValueChips;
var React = _interopRequireWildcard(require("react"));
var _qa = require("../../utils/qa");
var _Chip = require("../Chip");
var _Tooltip = require("../Tooltip");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// Type definition for token objects with expected properties

function defaultResolveTokenValue(_ref) {
  let {
    token,
    disabled,
    onDismiss,
    testId
  } = _ref;
  // Type assertion to access expected properties
  const tokenWithProps = token;
  const tokenTestId = (0, _qa.generateTestId)({
    base: testId,
    slot: `chip-${tokenWithProps?.key}`
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.Tooltip, {
    body: tokenWithProps?.label,
    elevation: "menu",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Chip.Chip, {
      onDismiss: _ => onDismiss?.(token),
      dismissable: true,
      semantic: 'primary',
      disabled: disabled,
      testId: tokenTestId,
      children: tokenWithProps?.label
    }, tokenWithProps?.key)
  });
}
function TokenValueChips(props) {
  const {
    values,
    disabled,
    locked,
    onDismiss,
    resolveTokenValue = defaultResolveTokenValue,
    testId
  } = props;
  return values.map(token => {
    const resolvedTokenValue = resolveTokenValue({
      token,
      onDismiss,
      disabled,
      locked,
      testId
    });
    return resolvedTokenValue;
  });
}
TokenValueChips.displayName = 'TokenValueChips';